let instance = null;

class DataLayerTracker {
  constructor() {
    if (instance) return instance;

    if (!window.trackingUtils) {
      console.warn('DatalayerTracker not found. All datalayer interactions will haven\'t effect');
      instance = this;
      this.trackingUtils = {};
      return instance;
    }

    this.trackingUtils = window.trackingUtils;

    instance = this;
    return instance;
  }


  trackShoppingDataReady(){
    if (!this.trackingUtils.trackShoppingDataReady) {
      console.warn('trackShoppingDataReady not found');
      return;
    }
    trackingUtils.trackShoppingDataReady();
  }

}

export default new DataLayerTracker();
